import React from 'react'
import { useTranslation } from 'react-i18next'

import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import { TextInput } from '../../../../../../common/inputs/textInput/TextInput'

const NumberOfSeats: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  screenName,
  insertionData,
  validationMessages,
  onChange,
  wrapperClassName = 'grid-item one-whole',
}) => {
  const { t } = useTranslation()
  return (
    <div className={`grid-item margin-top-l ${wrapperClassName}`}>
      <TextInput
        id='number-of-seats'
        propertyName='numberOfSeats'
        placeholder=''
        label={<span>{t('wizard.screen.otherFacilities.numberOfSeats', 'NumberOfSeats')}</span>}
        value={insertionData.numberOfSeats}
        maxLength={6}
        type='number'
        errors={validationMessages!.numberOfSeats ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}
export default NumberOfSeats
